<script setup lang="ts">
import * as Ecology from '~/assets/ecology'
import { UiAsset } from '~/components/ui'
</script>

<template>
  <section id="ecology" class="py-16 bg-primary-500 overflow-hidden">
    <div class="max-w-7xl mx-auto px-4">
      <div class="md:flex md:space-x-4">
        <div class="md:w-1/2 mb-8 md:mb-0">
          <div class="h-full flex flex-col justify-center pr-12">
            <span class="font-semibold text-accent-500 tracking-wider uppercase">
              {{ $t('pages.index.ecology.suptitle') }}
            </span>
            <h2 class="font-heading mt-1 mb-5 text-2xl font-semibold text-white md:text-3xl">
              {{ $t('pages.index.ecology.title') }}
            </h2>
            <p class="text-gray-300 md:text-justify">
              {{ $t('pages.index.ecology.content') }}
            </p>
          </div>
        </div>
        <div class="md:w-1/2">
          <div class="flex flex-wrap md:h-full items-center">
            <div class="relative md:h-56 xl:h-72">
              <div class="flex space-x-4 sm:whitespace-nowrap md:absolute">
                <div v-for="(image, idx) in Ecology"
                     :key="idx"
                >
                  <div class="aspect-square md:h-56 xl:h-72 rounded-lg overflow-hidden">
                    <UiAsset :src="image"
                             alt="Ecology"
                             class="object-center object-cover w-full h-full"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
